import React from "react";

export const BtnHome = ({
  onClick,
  colorBack,
  message,
  fontSizeHo = "12px",
  colorHo = "white",
  paddingHo = "1.5rem",
}) => {
  const styleBtn = {
    color: colorHo,
    backgroundColor: colorBack,
    fontSize: fontSizeHo,
    width: "fit-content",
    padding: `1rem ${paddingHo}`,
    margin: "1.23rem 0",
  };
  return (
    <>
      {" "}
      <button
        onClick={onClick}
        style={styleBtn}
        className="back-home-link btn-ho primary-ho"
      >
        {message}
      </button>
    </>
  );
};

export default BtnHome;
